import ChoiceTask from './ChoiceTask';
import DatePickTask from './DatePickTask';
import FileTask from './FileTask';
import MultiTextFieldTask from './MultiTextFieldTask';
import TextFieldTask from './TextFieldTask';

const StageTask = ({ response }) => {
  const getTask = () => {
    switch (response?.task.widget) {
      case 'File':
        return <FileTask taskResponse={response} />;
      case 'Option':
        return <ChoiceTask taskResponse={response} />;
      case 'MultiTextField':
        return <MultiTextFieldTask response={response} />;
      case 'TextField':
        if (response?.task.widget_parameters.type === 'date') {
          return <DatePickTask taskResponse={response} />;
        } else {
          return <TextFieldTask taskResponse={response} />;
        }
    }
  };
  return getTask();
};

export default StageTask;
